import dayjs, { Dayjs } from "dayjs";

import { ViewingTimeSlotItem } from "./types";

const TIME_FORMAT = "HH:mm";

export function parseTimeValue(value?: string | null): Dayjs | null {
  if (!value) return null;
  const parsed = dayjs(value, TIME_FORMAT);
  return parsed.isValid() ? parsed : null;
}

export function formatTimeValue(value?: Dayjs | null): string {
  if (!value || !value.isValid()) return "";
  return value.format(TIME_FORMAT);
}

function toMinutes(hhmm: string): number {
  const [hours, minutes] = hhmm.split(":").map(Number);
  return hours * 60 + minutes;
}

export function isValidTimeRange(startTime: string, endTime: string): boolean {
  if (!startTime || !endTime) return false;
  return toMinutes(startTime) < toMinutes(endTime);
}

/** True when [startA, endA) overlaps [startB, endB). Adjacent slots (end === next start) are allowed. */
export function doTimeRangesOverlap(
  startA: string,
  endA: string,
  startB: string,
  endB: string
): boolean {
  return toMinutes(startA) < toMinutes(endB) && toMinutes(startB) < toMinutes(endA);
}

export function findOverlappingSlot(
  startTime: string,
  endTime: string,
  slots: ViewingTimeSlotItem[],
  excludeUid?: string | null
): ViewingTimeSlotItem | undefined {
  return slots.find((slot) => {
    if (excludeUid && slot.uid === excludeUid) return false;
    return doTimeRangesOverlap(startTime, endTime, slot.startTime, slot.endTime);
  });
}
